import {AuthoringSupplementModelV1} from 'resources/GeneratedModels/AuthoringSupplement/AuthoringSupplementModel.v1';
import {extensions} from './authoringSupplement.extensions';
import {validators} from './authoringSupplement.validators';

AuthoringSupplementModelV1.extend(extensions);
AuthoringSupplementModelV1.addValidators(validators);

export {AuthoringSupplementModelV1};
